import { Controller } from "@hotwired/stimulus"
import { FullStory } from "@fullstory/browser"

export default class extends Controller {
  static values = {
    user: Object,
    building: Object,
  }

  connect() {
    const user = this.userValue
    const building = this.buildingValue

    if (!this.fullStoryEnabled()) {
      FullStory("shutdown")
      return
    }

    if (user.id) {
      FullStory("setIdentity", {
        uid: user.id,
        properties: {
          displayName: user.name,
          email: user.email,
          isInternal: user.internal_admin,
          role: user.top_role,
          newNavigation: user.new_navigation,
        }
      })
    }

    if (building.id) {
      FullStory("setProperties", {
        type: "page",
        properties: {
          buildingId: building.id,
          buildingSize: building.size,
          buildingType: building.type,
        }
      })
    }
  }

  fullStoryEnabled() {
    return document.querySelector("meta[name=fullstory]")?.content === "true"
  }
}
